'use client';

import { firebaseConfig } from '@/firebase/config';
import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Hardened Initialization for App Hosting & SSR.
 * Always uses explicit config to prevent 'app/no-options' and 'auth/invalid-api-key' errors.
 */
export function initializeFirebase() {
  if (!firebaseConfig.apiKey) {
    console.error("Firebase API Key is missing. Check your environment variables.");
  }

  const app = getApps().length > 0 
    ? getApp() 
    : initializeApp(firebaseConfig);

  return {
    firebaseApp: app,
    auth: getAuth(app),
    firestore: getFirestore(app)
  };
}

export function getSdks(firebaseApp: FirebaseApp) {
  return {
    firebaseApp,
    auth: getAuth(firebaseApp),
    firestore: getFirestore(firebaseApp)
  };
}

export * from './provider';
export * from './client-provider';
export * from './firestore/use-collection';
export * from './firestore/use-doc';
export * from './non-blocking-updates';
export * from './non-blocking-login';
export * from './errors';
export * from './error-emitter';
